import React from "react";
import PropTypes from "prop-types";

export const CloseCircleIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" {...props}>
    <circle
      cx="12"
      cy="12"
      r="11"
      stroke={props.color ? props.color : "#FF7F7F"}
      strokeWidth="1"
      fill="none"
    />
    <path
      d="M15.854 8.146a.5.5 0 0 0-.707 0L12 11.293 8.854 8.146a.5.5 0 0 0-.707.707L11.293 12l-3.146 3.146a.5.5 0 0 0 .707.708L12 12.707l3.146 3.146a.5.5 0 1 0 .708-.706L12.707 12l3.146-3.146a.5.5 0 0 0 .001-.708z"
      fill={props.color ? props.color : "#FF7F7F"}
    />
  </svg>
);
CloseCircleIcon.propTypes = {
  color: PropTypes.string,
};
